import { useEffect, useRef, useState, useCallback } from 'react';

export function useIdleTimeout({ timeoutMinutes = 30, warningMinutes = 2, onIdle, enabled = true }) {
  const [showWarning, setShowWarning] = useState(false);
  const timeoutRef = useRef(null);
  const warningRef = useRef(null);
  const onIdleRef = useRef(onIdle);

  useEffect(() => { onIdleRef.current = onIdle; }, [onIdle]);

  const reset = useCallback(() => {
    if (!enabled) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);
    setShowWarning(false);
    warningRef.current = setTimeout(() => setShowWarning(true),
      (timeoutMinutes - warningMinutes) * 60 * 1000);
    timeoutRef.current = setTimeout(() => {
      if (onIdleRef.current) onIdleRef.current();
    }, timeoutMinutes * 60 * 1000);
  }, [enabled, timeoutMinutes, warningMinutes]);

  useEffect(() => {
    if (!enabled) return;
    const events = ['mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach(e => window.removeEventListener(e, reset));
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (warningRef.current) clearTimeout(warningRef.current);
    };
  }, [enabled, reset]);

  return { showWarning, extend: reset };
}
